import AirBarGrey from "./AirBarGrey.vue";
export default AirBarGrey;
